import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  styled,
  Text,
  TextTag,
  TokenTextAppearance,
  TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { minimalScreenWidth } from '@/common/breakpoints';
const StyledLegalNotice = styled.section`
  width: 100%;
  display: flex;
  gap: ${(props) => props.theme.size.dynamic0020};
  padding-top: ${(props) => props.theme.size.static150};
  padding-left: ${(props) => props.theme.size.dynamic0150};
  padding-right: ${(props) => props.theme.size.dynamic0150};

  @media screen and ${minimalScreenWidth.l} {
    padding-top: ${(props) => props.theme.size.static150};
    padding-left: ${(props) => props.theme.size.dynamic0250};
    padding-right: ${(props) => props.theme.size.dynamic0250};
  }

  @media screen and ${minimalScreenWidth.xl} {
    padding-top: ${(props) => props.theme.size.static150};
    padding-left: ${(props) => props.theme.size.dynamic0450};
    padding-right: ${(props) => props.theme.size.dynamic0450};
  }
`;

export const LegalNotice: React.FC = () => {
  const { t } = useTranslation();

  return (
    <StyledLegalNotice data-testid="legal-notice">
      <Text
        tag={TextTag.p}
        color={TokenTextColor.secondary}
        appearance={TokenTextAppearance.label100}
      >
        <Text tag={TextTag.span} appearance={TokenTextAppearance.label100} bold>
          {t('legalNotice.heading')}
        </Text>{' '}
        <Text tag={TextTag.span} appearance={TokenTextAppearance.label100}>
          {t('legalNotice.description')}
        </Text>
      </Text>
    </StyledLegalNotice>
  );
};
